export class OrdinamentoVO {
    elemento: string;
    direzione: number; //1 DESC, O ASC   
}